import { Button } from "@/components/button";
import { Dialog, DialogBody, DialogCloseButton } from "@/components/dialog";
import { Modal } from "@/components/modal";
import { AlertTriangle } from "@/features/brands/edit/components/knowledge/components/icons/AlertTriangleIcon";

interface DiscardNoteModalProps {
  readonly isOpen: boolean;
  readonly onClose: () => void;
  readonly onConfirm: () => void;
}

export function DiscardNoteModal({
  isOpen,
  onClose,
  onConfirm,
}: DiscardNoteModalProps) {
  return (
    <Modal isOpen={isOpen} onOpenChange={onClose}>
      <Dialog>
        <DialogCloseButton />
        <DialogBody>
          <div className="flex flex-col gap-4">
            <div className="flex w-[48px] h-[48px] p-[12px] content-center items-center rounded-full bg-[#FEF0C7]">
              <AlertTriangle />
            </div>
            <div className="flex flex-col gap-1">
              <h2 className="text-lg font-semibold text-text-primary">
                Discard unsaved note?
              </h2>
              <p className="text-text-tertiary">
                You have started writing an internal note. If you leave now,
                everything you wrote will be lost.
              </p>
            </div>
          </div>
        </DialogBody>
        <div className="flex items-center gap-3 border-border-primary p-6">
          <Button
            className="flex-1 bg-[#DC6803] text-white"
            onPress={onConfirm}
            variant="plain"
          >
            Discard note
          </Button>
          <Button
            className="flex-1"
            color="gray"
            onPress={onClose}
            variant="secondary"
          >
            Keep editing
          </Button>
        </div>
      </Dialog>
    </Modal>
  );
}
